import { Button } from "@mui/material";

import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";

import {
  clearBinOverrides,
  selectIsPreviousBinFlow
} from "./autostorePutaway.slice";

export const ClearBinOverridesButton = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const isPreviousBinFlow = useAppSelector(selectIsPreviousBinFlow);

  return (
    <Button
      variant="subtle"
      size="large"
      onClick={() => dispatch(clearBinOverrides())}
      disabled={isPreviousBinFlow}
    >
      {t("food safety complete")}
    </Button>
  );
};
